/* eslint-disable no-undef */
/* eslint-disable quotes */

import '/Assets/js/common/telemetry-init.js';

// Common UI Components
import '/Assets/js/common/dropdown-handler.js';
import '/Assets/js/common/sticky.js';
import '/Assets/js/common/block-foldable-content.js';
import '/Assets/js/common/match-content-height.js';
import '/Assets/js/common/collapse-toggle.js';
import { getCurrentLanguage } from '/Assets/js/common/utilities.js';

// Site-wide features
import '/Features/Header/js/navigation-menu.js';
import '/Features/Footer/wechat.js';
import '/Features/Login/site-login.js';
import '/Features/Forms/js/utm-tracking.js';
import '/Features/Forms/js/attribution-runtime.js';
import '/Features/MediaGallery/js/image-lazy-load.js';
import SiteSearch from '/Features/Search/js/site-search.js';
import NotificationBar from '/Features/NotificationBar/notificationBar.js';
import Triggers from '/Integrations/Dynamics365/Triggers/triggers.js';
import ButtonBlock from '/Features/Components/Button/button-block';

// ========================================
// DYNAMIC LOADERS
// ========================================
// These check for DOM elements before loading heavy features.
// Only the loader is in this bundle; the actual feature code is in a separate chunk.
import '/Assets/js/common/modal-loader.js'; // Lazy-load modal handler on first modal interaction
import '/Assets/js/common/css-chunk-loader.js';
import '/Assets/libs/tabs/tabs-loader.js';
import '/Assets/libs/PopoverTooltip/popover-tooltip-loader.js';
import '/Features/Forms/js/optimizely-forms-loader.js';
import '/Features/Products/TorchesAndConsumables/js/torch-consumables-loader.js';
import '/Features/Calculators/PowermaxPaybackCalculator/powermax-payback-calculator-loader.js';
import '/Features/Calculators/PlatesaverCostSavingsCalculator/platesaver-loader.js';
import '/Features/ImageDownload/js/image-download-center-loader.js';
import '/Features/OptionalModules/js/optional-modules-loader.js';
import '/Features/WhereToBuy/js/where-to-buy-loader.js';
import '/Features/WhereToBuy/js/where-to-buy-results-loader.js';
import '/Features/ResponsiveTable/js/responsive-table-loader.js';
import '/Features/SetupFileRequest/js/subscription-setup-file-request-loader.js';
import '/Features/SubscriptionPlans/js/subscriptions-loader.js';
import '/Features/Faqs/js/faq-listing-page-loader.js';
import '/Features/MediaListing/js/media-listing-loader.js';
import '/Features/Documents/js/document-listing-page-loader.js';
import '/Features/Search/js/search-results-loader.js';
import '/Features/SupportByProduct/js/resources-by-product-loader.js';
import '/Features/SupportByProduct/js/resources-by-product-block-loader.js';
import '/Features/Products/Listing/js/product-listing-page-loader.js';
import '/Features/Pagination/js/pagination-loader.js';
import '/Features/Forms/js/cascading-form-container-block-loader.js';
import '/Assets/libs/read-more/read-more-loader.js';
import '/Features/MediaGallery/js/media-gallery-vanilla-loader.js';
import '/Features/CustomerStories/js/customer-stories-block-loader.js';
import '/Features/HeroShot/js/hero-shot-slider-loader.js';
import '/Assets/libs/table-horizontal-scroller/table-horizontal-scroller-loader.js';
import '/Features/Components/ContactUs/js/contact-us-block-loader.js';
import '/Features/Login/LoginBlock/js/login-block-loader.js';
import '/Features/GlobalLanding/js/global-landing-loader.js';
import '/Features/Products/Common/js/product-page-loader.js';
import '/Features/Products/Common/js/legacy-products-loader.js';

// ========================================
// INITIALIZATION & GLOBAL EXPORTS
// ========================================
window.getCurrentLanguage = getCurrentLanguage;

// Enable JS features
document.body.dataset.jsEnabled = 'true';

// Initialize site-wide components
let d365Triggers = new Triggers();
d365Triggers.init();

let notificationBar = new NotificationBar('notificationBar', 'accepted', 30);
notificationBar.init();

let buttonBlock = new ButtonBlock();
buttonBlock.init();

let siteSearch = new SiteSearch();
siteSearch.init();

// Global site CSS
import 'Assets/scss/hypertherm.scss';
